/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImplantGroup } from 'app/shared/model/implant-group.model';
import { IDeviceManufacurer } from 'app/shared/model/device-manufacurer.model';
import { ICatalogDefinitions } from 'app/shared/model/catalog-definitions.model';
import { MRISSafety } from 'app/shared/model/enumerations/mris-safety.model';

export interface IImplant {
  id?: string;
  name?: string;
  active?: boolean;
  addedBy?: string | null;
  timestampentry?: number;
  dunsNumber?: string | null;
  brandName?: string | null;
  deviceDescription?: string | null;
  biodegradable?: boolean;
  radioActive?: boolean;
  mriSafety?: keyof typeof MRISSafety;
  lastupdated?: number;
  unit?: string | null;
  quantity?: string | null;
  price?: number | null;
  cursor?: number;
  microSec?: number;
  group?: IImplantGroup;
  manufacturer?: IDeviceManufacurer | null;
  catalog?: ICatalogDefinitions | null;
}

export const defaultValue: Readonly<IImplant> = {
  active: false,
  biodegradable: false,
  radioActive: false,
};
